function initImageTextCarousels() {
  document.querySelectorAll('.image-text-carousel').forEach((el) => {
    if (el.dataset.initialized) return;
    el.dataset.initialized = 'true';

    const slides = Array.from(el.querySelectorAll('.image-text-carousel__slide'));
    const dots = Array.from(el.querySelectorAll('.image-text-carousel__dot'));
    const prevBtn = el.querySelector('.image-text-carousel__arrow--prev');
    const nextBtn = el.querySelector('.image-text-carousel__arrow--next');
    const speed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
    let currentIndex = 0;
    let timer = null;

    function go(index, isManual) {
      if (slides.length === 0) return;
      const newIndex = (index + slides.length) % slides.length;

      slides[currentIndex].classList.remove('is-active');
      dots[currentIndex] && dots[currentIndex].classList.remove('is-active');

      slides[newIndex].classList.add('is-active');
      dots[newIndex] && dots[newIndex].classList.add('is-active');

      currentIndex = newIndex;

      if (isManual) {
        stopAutoplay();
        startAutoplay();
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (slides.length <= 1) return;
      timer = setInterval(function () {
        go(currentIndex + 1, false);
      }, speed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(currentIndex - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(currentIndex + 1, true); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i, true); });
    });

    startAutoplay();

    el.addEventListener('mouseenter', stopAutoplay);
    el.addEventListener('mouseleave', startAutoplay);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImageTextCarousels);
} else {
  initImageTextCarousels();
}